
















import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import WindowResizeListener from '@/abstract/WindowResizeListener'
import Emoji from '@/components/Emoji/Emoji.vue'

interface Methods {
  handleInput: (text: string) => void
  handleEmoji: (emoji: string) => void
  handleValidate: () => void
}

interface Computed {
  className: string
  readonlyText: string
}

interface Props {
  isEdit: boolean
  value: string
  rows?: number
  maxLength?: number
  placeholder?: string
  fieldClass?: string
  readonlyValue?: string
}

export default mixins(WindowResizeListener).extend<
  {},
  Methods,
  Computed,
  Props
>({
  components: {
    Emoji,
  },
  props: {
    isEdit: {
      required: true,
    },
    value: {
      required: true,
    },
    rows: {
      default: () => undefined,
    },
    maxLength: {
      default: () => undefined,
    },
    placeholder: {
      default: () => undefined,
    },
    fieldClass: {
      default: () => undefined,
    },
    readonlyValue: {
      default: () => undefined,
    },
  },
  computed: {
    className(): string {
      return this.fieldClass || ''
    },
    readonlyText(): string {
      return this.readonlyValue || this.value
    },
  },
  methods: {
    handleInput(text: string): void {
      this.$emit('input', text)
    },
    handleEmoji(emoji: string): void {
      const element = (this.$refs.textarea as Vue).$el as HTMLTextAreaElement
      const { selectionEnd } = element

      const beforeText = this.value.slice(0, selectionEnd)
      const afterText = this.value.slice(selectionEnd)

      this.$emit('input', `${beforeText}${emoji}${afterText}`)

      this.$nextTick().then(() => {
        const newCursorPos = selectionEnd + emoji.length
        element.focus()
        element.setSelectionRange(newCursorPos, newCursorPos)
      })
    },
    handleValidate(): void {
      if (this.value && this.maxLength && this.value.length >= this.maxLength) {
        this.$emit('on-validate')
      }
    },
  },
})
